import { ChevronDown, Loader2 } from "lucide-react";

interface TradingPair {
  id: string;
  pair: string;
  asset: string;
  assetIcon?: string;
  assetName?: string;
  type?: string;
  formattedAvailableAmount?: string;
  [key: string]: unknown;
}

interface Asset {
  assetId: string;
  asset: string;
  [key: string]: unknown;
}

interface PairSelectionContentProps {
  selectedAsset: Asset | null | undefined;
  currentPairs: TradingPair[] | null | undefined;
  onPairSelect: (pair: TradingPair) => void;
  emptyStateMessage?: string;
  loadingMessage?: string;
}

export default function PairSelectionContent({
  selectedAsset,
  currentPairs,
  onPairSelect,
  emptyStateMessage = "Choose an asset to see payment options",
  loadingMessage = "Loading payment options...",
}: PairSelectionContentProps) {
  return (
    <div className="flex flex-col space-y-3 max-h-72 overflow-y-auto">
      {!selectedAsset ? (
        <div className="flex flex-col items-center justify-center py-8">
          <div className="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-3">
            <ChevronDown className="h-6 w-6 text-gray-400" />
          </div>
          <p className="text-sm text-gray-700 font-medium">
            Select an asset first
          </p>
          <p className="text-xs text-gray-500 mt-1">{emptyStateMessage}</p>
        </div>
      ) : !currentPairs ? (
        <div className="flex flex-col items-center justify-center py-8">
          <Loader2 className="h-8 w-8 animate-spin text-brand-primary mb-3" />
          <p className="text-sm text-gray-500">{loadingMessage}</p>
        </div>
      ) : (
        currentPairs.map((pair) => {
          return (
            <button
              key={pair.id}
              onClick={() => onPairSelect(pair)}
              className="flex items-center gap-3 px-3 py-3 border rounded-lg border-transparent bg-gray-50 hover:border-rose-200"
            >
              <img
                src={pair.assetIcon}
                alt={pair.assetName}
                className="w-6 h-6"
              />
              <div className="flex flex-col text-left">
                <span className="text-sm">{pair.assetName}</span>
                <span className="text-xs text-gray-500">
                  {pair.asset.toUpperCase()}
                </span>
              </div>
            </button>
          );
        })
      )}
    </div>
  );
}
